import { Box } from "@mui/system";

import { ProviderFinderBox } from "../styles/style";
import { providerFinder, redirectUri } from "../../../constants/Config";
import { UserPageTrack } from "../../../models/User";
import { useEffect } from "react";
import { getCurrnetPageFullPath, getUaserPageViewPayload } from "../../../utils";
import { ApplicationTitles } from "../../../constants/HomePage";
import { getValidMessageType } from "../../../constants/User";
export interface PropsFromDispatch {
  postUserPageTrack: (payload: UserPageTrack) => void;
}

type AllProps = PropsFromDispatch;
const ProviderFinder: React.FC<AllProps> = ({postUserPageTrack}) => {


  useEffect(() => {
    postUserPageTrack(
      getUaserPageViewPayload(
        getValidMessageType(ApplicationTitles.PROVIDER_FINDER),
        getCurrnetPageFullPath(),
        redirectUri,
        ""
      )
    );
  }, []);
  return (
    <Box
      component="iframe"
      src={providerFinder}
      title="Provider Finder"
      sx={ProviderFinderBox}
    />
  );
};

export default ProviderFinder;
